import Header from "../components/Header";
import Hero from "../components/Hero";
import Vitals from "../components/Vitals";
import Profile from "../components/Profile";
import TeamAffiliations from "../components/TeamAffiliations";
import Bio from "../components/Bio";
import HighlightReel from "../components/HighlightReel";
import FilmLinks from "../components/FilmLinks";
import UpcomingTournaments from "../components/UpcomingTournaments";
import Press from "../components/Press";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { ProfileProvider } from "../context/ProfileContext";

export default function LandingPage() {
  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <ProfileProvider>
      <main className="bg-[#0A0A0A] min-h-screen" data-testid="landing-page">
        <Header onContactClick={scrollToContact} />
        <Hero />
        <Vitals />
        <Profile />
        <TeamAffiliations />
        <HighlightReel />
        <Bio />
        <FilmLinks />
        <UpcomingTournaments />
        <Press />
        <Contact />
        <Footer />
      </main>
    </ProfileProvider>
  );
}
